import {UAParser} from 'ua-parser-js';

import countries from '../json/countries.json';

const iconTextMap = {
    // Browsers
    'chrome':{ icon: 'lab la-chrome', name: 'کروم'},
    'firefox':{ icon: 'lab la-firefox', name: 'فایرفاکس'},
    'safari':{ icon: 'lab la-safari', name: 'سافاری'},
    'edge':{ icon: 'lab la-edge', name: 'مایکروسافت اج'},
    'opera':{ icon: 'lab la-opera', name: 'اپرا'},
    'ie':{ icon: 'lab la-internet-explorer', name: 'اینترنت اکسپلورر'},
    // Operating Systems
    'windows':{ icon: 'lab la-windows', name: 'ویندوز'},
    'mac os':{ icon: 'lab la-apple', name: 'مک‌اواس'},
    'linux':{ icon: 'lab la-linux', name: 'لینوکس'},
    'ubuntu':{ icon: 'lab la-ubuntu', name: 'ابونتو'},
    'android':{ icon: 'lab la-android', name: 'اندروید'},
    'ios':{ icon: 'lab la-apple', name: 'آی‌او‌اس'},
    // Default
    'default':{ icon: 'las la-question-circle', name: 'ناشناخته'}
};

export function getCurrentJalaliYear() {
    return  new Date().toLocaleDateString('fa-IR').split('/')[0];
}

export function toPersianDigits(str) {
    if (str === null || str === undefined) return '';
    const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    return str.toString().replace(/\d/g, x => persianDigits[parseInt(x)]);
}

export function normalizePhoneNumber(phoneNumber) {
    if (!phoneNumber) return "";
    const cleanedNumber = phoneNumber.toString().trim().replace(/[^\d+]/g, '');
    const match = cleanedNumber.match(/^(?:0|0098|\+98|98)?(9\d{9})$/);
    if (match) {
        return `98${match[1]}`;
    } else {
        return phoneNumber;
    }
}

export function formatPhoneNumberForDisplay(phone) {
    if (!phone || !phone.startsWith('98') || phone.length !== 12) {
        return phone;
    }
    const localPart = phone.substring(2);
    const formatted = `${localPart.substring(6, 10)} ${localPart.substring(3, 6)} 0${localPart.substring(0, 3)}`;
    return toPersianDigits(formatted);
}

export function formatPhoneNumberForInput(phone) {
    if (!phone || !phone.startsWith('98') || phone.length !== 12) {
        return '';
    }
    return `0${phone.substring(2)}`;
}

export function formatDate(dateString) {
    if (!dateString) return '-';

    const date = new Date(dateString + 'Z');
    const now = new Date();
    const dateToCompare = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const yesterday = new Date(today); yesterday.setDate(today.getDate() - 1);
    const tomorrow = new Date(today); tomorrow.setDate(today.getDate() + 1);
    const lastWeek = new Date(today); lastWeek.setDate(today.getDate() - 6);
    const isSameYear = now.getFullYear() === date.getFullYear();
    const timeOptions = { hour: '2-digit', minute: '2-digit' };
    const dateOptions = { year: isSameYear ? undefined : 'numeric', month: 'long', day: 'numeric' };
    const weekDayName = date.toLocaleDateString('fa-IR', { weekday: 'long' })
    const fullTime = date.toLocaleTimeString('fa-IR', timeOptions);
    const fullDate = date.toLocaleDateString('fa-IR', dateOptions);

    if (dateToCompare.getTime() === today.getTime()) {
        return `امروز، ${fullTime}`;
    } else if (dateToCompare.getTime() === yesterday.getTime()) {
        return `دیروز، ${fullTime}`;
    } else if (dateToCompare.getTime() === tomorrow.getTime()) {
        return `فردا، ${fullTime}`;
    } else if (dateToCompare < today && dateToCompare >= lastWeek) {
        return `${weekDayName}، ${fullTime}`;
    } else {
        return `${fullDate}، ${fullTime}`;
    }
}

export function parseUserAgent(uaString) {
    const parser = new UAParser(uaString);
    const result = parser.getResult();

    const browserName = (result.browser.name || "").toLowerCase().replace("mobile","").trim();
    const osName = (result.os.name || "").toLowerCase().replace("mobile","").trim();

    const browser = iconTextMap[browserName] || iconTextMap['default'];
    const os = iconTextMap[osName.toLowerCase()] || iconTextMap['default'];

    return {
        browser: {
            name: browser.name,
            version: result.browser.version,
            icon: browser.icon
        },
        os: {
            name: os.name,
            version: result.os.version,
            icon: os.icon
        }
    };
}

export function getCountryName(countryCode){
    if (!countryCode) {
        return "نامشخص";
    } else if (countryCode === "LOCAL"){
        return "میزبان محلی";
    } else if (countryCode === "UNKNOWN"){
        return "نامشخص";
    } else {
        try {
            return countries[countryCode];
        } catch (e) {
            return "نامشخص"
        }
    }
}

export function getCountryFlag(countryCode) {
    if (!countryCode || countryCode.length !== 2) {
        return '<span class="fi fi-xx"></span>';
    } else {
        return `<span class="fi fi-${countryCode.toLowerCase()}"></span>`;
    }
}

export const formatCurrency = (num) => new Intl.NumberFormat('fa-IR', { maximumFractionDigits: 0 }).format(Math.abs(num));

export function translateContactType(type) {
    const typeMap = {
        'customer': 'مشتری',
        'supplier': 'تامین‌کننده',
        'employee': 'کارمند',
        'partner': 'شریک',
        'bank': 'بانک',
        'other': 'سایر'
    };
    return typeMap[type] || 'نامشخص';
}

export function formatCreditTerm(days) {
    if (days === 0)
        return 'نقدی'
    const prefix = days < 0 ? 'پرداخت' : 'دریافت';
    let duration;
    let unit;
    days = Math.abs(days)
    if (days >= 30 && (days % 30 === 0)) {
        duration = Math.round(days / 30);
        unit = 'ماهه';
    } else if (days % 7 === 0) {
        duration = days / 7;
        unit = 'هفته‌ای';
    } else {
        duration = days;
        unit = 'روزه';
    }
    return `${prefix} ${toPersianDigits(duration)} ${unit}`;
}